export function loader() {
    throw new Response(null, { status: 404 });
}

// Due to the loader, this component will never be rendered, but it's still needed
// because this isn't a "pathless" route.
export default () => <></>;
